import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.css'],
  providers: [],
})
export class SplashScreenComponent implements OnInit {
  selectedPartner = '';
  xerxesState = localStorage.getItem('xerxesState');
  dashboardName = localStorage.getItem('dashboard_name');
  partnersList: any;
  @ViewChild('idpLabel') labelDiv: ElementRef;
  constructor() {}

  ngOnInit() {
    this.partnersList = environment.partners;
    setTimeout(() => {
      this.labelDiv.nativeElement.style.visibility = 'visible';
    }, 300);
  }
  singleSignOn(partner: any) {
    this.selectedPartner = partner;
    localStorage.setItem('ssoPartner', this.selectedPartner);
    switch (this.selectedPartner) {
      case 'sky-group': {
        const ssoURL = environment.EU_xerxesUrl;
        const appName = environment.EU_xerxesApp;
        this.signOnUser(ssoURL, appName);
        break;
      }

      case 'foxtel': {
        const ssoURL = environment.APAC_xerxesUrl;
        const appName = environment.APAC_xerxesApp;
        this.signOnUser(ssoURL, appName);
        break;
      }

      default: {
        const ssoURL = environment.NA_xerxesUrl;
        const appName = environment.NA_xerxesApp;
        this.signOnUser(ssoURL, appName);
        break;
      }
    }
  }
  signOnUser(xerxesUrl: any, xerxesApp: any) {
    if (this.xerxesState) {
      window.location.href =
        xerxesUrl +
        'oauth/authorize?client_id=' +
        xerxesApp +
        '&response_type=code&partner_id=' +
        this.selectedPartner +
        '&redirect_uri=' +
        location.protocol +
        '//' +
        location.hostname +
        (location.port ? ':' + location.port : '') +
        '/login&state=' +
        btoa(this.xerxesState);
    } else {
      window.location.href =
        xerxesUrl +
        'oauth/authorize?client_id=' +
        xerxesApp +
        '&partner_id=' +
        this.selectedPartner +
        '&response_type=code&redirect_uri=' +
        location.protocol +
        '//' +
        location.hostname +
        (location.port ? ':' + location.port : '') +
        '/login';
    }
  }
}